import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
`;

export const H1 = styled.h1`
  font-size: 30px;
`;

export const Backgroud = styled.img`
  width: 80%;
`;
